import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=63041cd4&scoped=true"
import script from "./ProgressBar.vue?vue&type=script&lang=ts"
export * from "./ProgressBar.vue?vue&type=script&lang=ts"
import style0 from "./ProgressBar.vue?vue&type=style&index=0&id=63041cd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63041cd4",
  null
  
)

export default component.exports